module.exports = __webpack_public_path__ + "img/3.3d7c80c6.jpg";